"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrictSet = void 0;
const IterableSet_1 = require("./IterableSet");
const StrictTypeGuard_1 = require("./StrictTypeGuard");
class StrictSet extends IterableSet_1.IterableSet {
    constructor(enforcedType, values) {
        super();
        this.guard = new StrictTypeGuard_1.StrictTypeGuard(enforcedType);
        if (values) {
            for (const value of values) {
                this.add(value);
            }
        }
    }
    get enforcedType() {
        return this.guard.type;
    }
    add(value) {
        this.guard.assertType(value);
        return super.add(value);
    }
    has(value) {
        this.guard.assertType(value);
        return super.has(value);
    }
    delete(value) {
        this.guard.assertType(value);
        return super.delete(value);
    }
}
exports.StrictSet = StrictSet;
//# sourceMappingURL=StrictSet.js.map